<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <Pay
        formSlug="statement-of-use-extension"
        stepBack="step-4"
        @init="init"
    ></Pay>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import Pay from '@/components/Pay.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Pay
    },
    data() {
        return {
            classes: []
        }
    },
    mounted() {
        to_top()
    },
    methods: {
        init(data) {
            this.classes = data.classes
        }
    },
    computed: {
        countElements() {
            let num = 4

            for (let i = 0; i < this.classes.length; i++) {
                if (this.classes[i].is_using_trademark) {
                    num += 2
                } else {
                    num += 1
                }
            }

            return this.classes.length ? num + 2 : 0
        }
    }
}
</script>
